import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { ErrorText } from 'src/components/ErrorText'
import { TextFieldComponent } from 'src/components/TextFieldComponent'
import DataContext from 'src/contexts/DataContext'
import { useCourseInfoHook } from 'src/hooks/useCourseInfoHook'

import { emitNotificationEvent } from 'src/events'
import {
  IValidateLoginJWT,
  useGetCandidateLoginToken,
  usePostValidateLoginJWT,
} from 'src/services/backend'
import backgroundLogo from '../../assets/images/background_logo.png'
import * as S from './styles'
import { Timer } from 'src/components/Timer'
const SecurityCodePage = () => {
  const navigate = useNavigate()
  const { registration, setRegistration } = useContext(DataContext)

  const [errorMsg, setErrorMsg] = useState('')
  const [courseLogo, setCourseLogo] = useState<string>()
  const [disableButtonSendCode, setdisableButtonSendCode] = useState(true)

  const { control, handleSubmit } = useForm({
    defaultValues: {
      candidateCode: registration.code!,
      token: '',
    },
  })
  const [getLoginToken, loginTokenResult] = useGetCandidateLoginToken()
  const [validateToken, postValidadeTokenResult] = usePostValidateLoginJWT()

  const toasts = {
    errorSendNewCode: () =>
      emitNotificationEvent({
        id: 'errorSendNewCode',
        type: 'error',
        title: 'Ops!',
        message:
          'Ocorreu um erro ao enviar o novo código. Tente fazer Login novamente.',
        isIndeterminate: false,
      }),
    successSendNewCode: () =>
      emitNotificationEvent({
        id: 'successSendNewCode',
        type: 'success',
        title: 'Sucesso!',
        message: 'Novo código enviado com sucesso',
        isIndeterminate: false,
      }),
    errorValidationCode: () =>
      emitNotificationEvent({
        id: 'errorSendNewCode',
        type: 'error',
        title: 'Erro!',
        message: 'Código inválido',
        isIndeterminate: false,
      }),
  }

  const sendNewCode = () => {
    const newData = {
      candidateCode: registration.code!,
      date: registration.date!,
    }

    getLoginToken(newData)
  }

  const onSubmit = (data: IValidateLoginJWT) => {
    data = {
      candidateCode: data.candidateCode,
      token: data.token,
    }
    validateToken(data)
  }

  useEffect(() => {
    if (!registration.code || !registration.date) navigate('/candidato')
  }, [])

  useEffect(() => {
    const timer = setTimeout(() => {
      setdisableButtonSendCode(false)
    }, 120000)

    if (!disableButtonSendCode) clearTimeout(timer)
  }, [disableButtonSendCode])

  useEffect(() => {
    if (postValidadeTokenResult.error) toasts.errorValidationCode()
  }, [postValidadeTokenResult])

  const currentCourseInfo = useCourseInfoHook({
    course: registration.candidate?.curseTypeName?.toLowerCase(),
  })

  useEffect(() => {
    if (loginTokenResult?.error) toasts.errorSendNewCode()
    if (loginTokenResult.status === 200) {
      toasts.successSendNewCode()
      setdisableButtonSendCode(true)
    }
  }, [loginTokenResult])

  useEffect(() => {
    currentCourseInfo && setCourseLogo(currentCourseInfo.logo_url)
  }, [currentCourseInfo])

  useEffect(() => {
    if (postValidadeTokenResult?.error) {
      setErrorMsg('Código inválido')
    } else {
      setErrorMsg('')
      if (postValidadeTokenResult.status === 200) {
        registration.setJWT(
          setRegistration,
          postValidadeTokenResult?.data?.response.jwt
        )
        navigate('/candidato')
      }
    }
  }, [postValidadeTokenResult])

  return (
    <S.ContainerFlex onSubmit={handleSubmit(onSubmit)}>
      <S.ContainerImage>
        <img src={backgroundLogo} alt="Imagem do logotipo da Germinare" />
      </S.ContainerImage>
      <S.Content>
        <S.ContainerImage>
          {/* <img src={courseLogo} alt="Imagem do logotipo da Germinare" /> */}
        </S.ContainerImage>
        <S.Title>Código de segurança</S.Title>
        <S.Typography>
          Enviamos um código de 6 números para os E-MAILS dos responsáveis
          cadastrados. Por favor, verifique sua caixa de entrada e a pasta de
          spam.
        </S.Typography>
        <S.GridContainer item xs={12}>
          <Controller
            name="token"
            control={control}
            render={({ field, fieldState }) => (
              <TextFieldComponent
                {...field}
                type="number"
                label={'Digite o código de segurança'}
                error={!!fieldState.error}
              />
            )}
          />
          {errorMsg && <ErrorText message={errorMsg} />}
        </S.GridContainer>
        <S.ButtonContainer>
          <S.Button
            variant={'contained'}
            type="submit"
            endIcon={<ArrowForwardIosIcon />}
          >
            Acessar área do candidato
          </S.Button>
          <S.Button disabled={disableButtonSendCode} onClick={sendNewCode}>
            Reenvio código por e-mail
            {disableButtonSendCode && <Timer />}
          </S.Button>
        </S.ButtonContainer>
      </S.Content>
    </S.ContainerFlex>
  )
}

export { SecurityCodePage }
